import {AElement} from "./AElement";
import {EElementType} from "../utils/EElementType";
import ModelsRegExp from "../../services/ModelsRegExp";

export class Gateway extends AElement {

    constructor(serialNumber: string, isScanned?: boolean) {
        super(EElementType.Gateway, serialNumber, isScanned, ModelsRegExp.elementSerialNumberGateway);
    }

    public static remapObjectToElement(object: any): Gateway | null {
        let element: Gateway | null = null;
        if(
            object._serialNumber
        ) {
            element = new Gateway(
                object._serialNumber,
                object._isScanned
            );
        }
        return element;
    }
}
